import { ResponseInterceptor } from './response.interceptor';
import { AuthService } from './auth.service';
//import { HttpClient } from '@angular/common/http';
//import { LoadingSpinnerService } from './../shared/services/loading-spinner.service';
import { AuthGuard } from './auth.guard';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './token.interceptor';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class AuthModule {

  constructor(){
  }

  public static forRoot():ModuleWithProviders{
    return {
      ngModule:AuthModule,
      providers:[
        AuthService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: TokenInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ResponseInterceptor,
          multi: true
        }             
      ]
    }
  }
 }



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts